import React from 'react';
import { useTranslation } from 'react-i18next';
import { OPEN_COOKIE_SETTINGS_EVENT } from './CookieConsent';

const MapConsentNotice = () => {
    const { t } = useTranslation();
    return <div style={{ minHeight: 220, width: '100%', padding: 24, background: '#f5f5f5', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        <strong style={{ marginBottom: 8 }}>{t('MapConsentRequired')}</strong>
        <button type="button" className="button ripple-effect" onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT))}>
            {t('OpenCookieSettings')}
        </button>
    </div>;
};

export default MapConsentNotice;
